module.exports = __webpack_public_path__ + "static/media/polygon.203d520f.png";